import React from 'react';

import { Point } from '../../../helpers/constants';
import {
  generateEndArrow,
  getArrowPoints,
  getIntersectionPoint,
  getParellelPoints2,
} from '../../../utils/math.util';
import HookablePoint from '../HookablePoint';

export function PolyLine(props: any) {
  const {
    points = [],
    lineColor,
    lineWidth,
    lineType,
    rn,
    showChannelPath,
    channelWidth,
    hookProperties,
    showPoints,
    showDirectionalArrow,
    labelFontSize,
  } = props;
  const [firstPoint = {}, ...restPoints] = points;
  const d =
    `M ${firstPoint.x} ${firstPoint.y}` +
    restPoints?.map((point: any) => `L ${point.x} ${point.y}`).join(' ');
  const pointPairs = points.reduce(
    (acc: any, curr: any, index: any, array: any) => {
      if (index === 0) {
        return acc;
      }
      const startPos = array[index - 1];
      const endPos = array[index];
      const { midPoint, endPoint } = getArrowPoints(startPos, endPos);
      acc.push([midPoint, endPoint]);
      return acc;
    },
    []
  );
  const channelBaseLines: any[] = [];
  const actualPairs = points.reduce(
    (acc: any, curr: any, index: any, array: any) => {
      if (index === 0) {
        return acc;
      }
      const startPos = array[index - 1];
      const endPos = array[index];
      const { point1, point2, point3, point4 } = getParellelPoints2(
        +startPos.x,
        +startPos.y,
        +endPos.x,
        +endPos.y,
        channelWidth
      );
      channelBaseLines.push({
        point1,
        point2,
        point3,
        point4,
      });
      acc.push([startPos, endPos]);
      return acc;
    },
    []
  );
  let channelPath = '';
  if (channelBaseLines.length > 0) {
    const [firstLinePoints, ...otherLinePoints] = channelBaseLines;
    const lastLinePoints = otherLinePoints[otherLinePoints.length - 1];
    channelPath = `M ${firstLinePoints.point3.x} ${firstLinePoints.point3.y} L ${firstLinePoints.point1.x} ${firstLinePoints.point1.y}`;

    channelBaseLines.forEach((val, index, arr) => {
      if (index === arr.length - 1) {
        return;
      }
      const curr = val;
      const next = arr[index + 1];
      const { x, y } = getIntersectionPoint(
        curr.point1.x,
        curr.point1.y,
        curr.point2.x,
        curr.point2.y,
        next.point1.x,
        next.point1.y,
        next.point2.x,
        next.point2.y
      );
      channelPath += ` L ${x} ${y}`;
    });
    if (lastLinePoints) {
      channelPath += `L ${lastLinePoints.point2?.x} ${lastLinePoints.point2?.y} L ${lastLinePoints.point4?.x} ${lastLinePoints.point4?.y}`;
    }
    channelBaseLines.reverse().forEach((val, index, arr) => {
      if (index === arr.length - 1) {
        return;
      }
      const curr = val;
      const next = arr[index + 1];
      const { x, y } = getIntersectionPoint(
        curr.point4.x,
        curr.point4.y,
        curr.point3.x,
        curr.point3.y,
        next.point4.x,
        next.point4.y,
        next.point3.x,
        next.point3.y
      );
      channelPath += ` L ${x} ${y}`;
    });
    channelPath += ` Z`;
  }
  return (
    <>
      <path
        d={d}
        stroke={lineColor}
        strokeWidth={lineWidth}
        strokeDasharray={lineType === 'dotted' ? '3' : '0'}
        fill="none"
      />
      {showDirectionalArrow &&
        pointPairs.map((pair: any) => {
          const [startPos, endPos] = pair;
          return (
            <>
              {/* <circle cx={startPos.x} cy={startPos.y} r="5" fill="red" /> */}
              <path
                d={generateEndArrow(startPos, endPos)}
                stroke={lineColor}
                strokeWidth={'1'}
                fill={'none'}
              />
            </>
          );
        })}
      {showChannelPath && (
        <path d={channelPath} stroke={lineColor} strokeWidth="1" fill="none" />
      )}
      {/* {channelBaseLines.map((channel: any, index: number) => {
        return (
          <>
            {' '}
            {addDebugPoints(
              channel.point1,
              channel.point2,
              channel.point3,
              channel.point4,
              channel.newPoint
            )}
          </>
        );
      })} */}

      {points.map((point: any) => {
        return (
          <>
            {showPoints && (
              <>
                <HookablePoint
                  x={point.x}
                  y={point.y}
                  radius={2}
                  id={point.pointLabel}
                  latitude={point.latitude}
                  longitude={point.longitude}
                  hookProperties={hookProperties}
                />
              </>
            )}
            <text
              x={point.x}
              y={point.y - 10}
              textAnchor="middle"
              fill={lineColor}
              strokeWidth="1px"
              fontSize={labelFontSize || '0.75em'}
            >
              {point.pointLabel?.toUpperCase()}
            </text>
          </>
        );
      })}
      <text
        x={firstPoint.x}
        y={firstPoint.y + 15}
        textAnchor="middle"
        fill={lineColor}
        strokeWidth="1px"
        fontSize={labelFontSize || '0.5em'}
      >
        {rn?.toUpperCase()}
      </text>
    </>
  );
}

// const addDebugPoints = (
//   p1: Point,
//   p2: Point,
//   p3: Point,
//   p4: Point,
//   newPoint: Point
// ) => {
//   const radius = 4;
//   const fillingColor = 'none';
//   const lineColor = 'red';
//   return (
//     <>
//       <circle
//         cx={p1.x}
//         cy={p1.y}
//         r={radius}
//         fill={fillingColor}
//         stroke={lineColor}
//         pointerEvents="visibleStroke"
//       />
//       <text x={p1.x + 10} y={p1.y}>
//         P1
//       </text>
//       {/*
//       <circle
//         cx={p2.x}
//         cy={p2.y}
//         r={radius}
//         fill={fillingColor}
//         stroke={lineColor}
//         pointerEvents="visibleStroke"
//       />
//       <circle
//         cx={p3.x}
//         cy={p3.y}
//         r={radius}
//         fill={fillingColor}
//         stroke={lineColor}
//         pointerEvents="visibleStroke"
//       />
//       <circle
//         cx={p4.x}
//         cy={p4.y}
//         r={radius}
//         fill={fillingColor}
//         stroke={lineColor}
//         pointerEvents="visibleStroke"
//       /> */}
//       <circle
//         cx={newPoint.x}
//         cy={newPoint.y}
//         r={radius}
//         fill={'green'}
//         stroke={lineColor}
//         pointerEvents="visibleStroke"
//       />
//     </>
//   );
// };
